export const MENU_OPEN = "MENU_OPEN";
export const MENU_CLOSE = "MENU_CLOSE";
export const MENU_TOGGLE = "MENU_TOGGLE";
